import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles.scss";
import { faClose } from "@fortawesome/free-solid-svg-icons";

type Props = {
  visible: boolean;
  onClose: () => void;
  info: JSX.Element
};

const InfoPopup = (props: Props) => {
  return (
    <div
      className="infoPopup"
      style={{ display: props.visible ? "flex" : "none" }}
    >
      <div style={{ display: "flex"}}>
        <FontAwesomeIcon
          icon={faClose}
          onClick={props.onClose}
          style={{
            color: "white",
            borderRadius: "50%",
            background: "black",
            padding: "5px 7px",
            marginBottom: "30px",
            marginLeft: "auto"

          }}
        />
      </div>
{
    props.info
}
    </div>
  );
};

export default InfoPopup;
